import type { CurrentManagement } from "../data/managementQueries";

/**
 * When signing in stops for a client whose management is ending, moved out of `OverviewRoute.tsx`
 * so the page file exports only its component. Decision 4 of 2026-09-24 put this date on Översikt's
 * Förvaltning row; the reasoning is on that page.
 */

/** plan.md section 4: "After the end date, access becomes read-only for 30 days." */
export const READ_ONLY_DAYS = 30;

/** A `date` column as the calendar day it names, never shifted by the reader's time zone. */
function parseDay(value: string | null): Date | null {
  const parts = value ? /^(\d{4})-(\d{2})-(\d{2})/.exec(value) : null;
  if (!parts) {
    return null;
  }
  const parsed = new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]));
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function addDays(day: Date, days: number): Date {
  return new Date(day.getFullYear(), day.getMonth(), day.getDate() + days);
}

/**
 * The day signing in stops for a client whose management is ending or has ended, or null when it is
 * not stopping or the date cannot be read.
 */
export function loginEndsOn(management: Pick<CurrentManagement, "status" | "scheduled_end_on" | "read_only_until">): Date | null {
  if (management.status === "read_only") {
    return parseDay(management.read_only_until);
  }
  if (management.status === "ending") {
    const end = parseDay(management.scheduled_end_on);
    return end ? addDays(end, READ_ONLY_DAYS) : null;
  }
  return null;
}
